import { Injectable, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Historique } from './historique.model';
import { HistoriqueService } from './historique.service';
@Injectable()
export class HistoriquePopupService {
    private isOpen = false;
    constructor (
        private datePipe: DatePipe,
        private modalService: NgbModal,
        private router: Router,
        private historiqueService: HistoriqueService

    ) {}

    open (component: Component, id?: number | any): NgbModalRef {
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;

        if (id) {
            this.historiqueService.find(id).subscribe(historique => {
                historique.dateCreation = this.datePipe.transform(historique.dateCreation, 'yyyy-MM-ddThh:mm');
                this.historiqueModalRef(component, historique);
            });
        } else {
            return this.historiqueModalRef(component, new Historique());
        }
    }

    historiqueModalRef(component: Component, historique: Historique): NgbModalRef {
        let modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static'});
        modalRef.componentInstance.historique = historique;
        modalRef.result.then(result => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        }, (reason) => {
            this.router.navigate([{ outlets: { popup: null }}], { replaceUrl: true });
            this.isOpen = false;
        });
        return modalRef;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/historique-popup.service.ts